import React, { useState } from 'react';
import { X } from 'lucide-react';
import StripeSubscriptionPaymentForm from '../vendor/StripeSubscriptionPaymentForm';
import ModalShell from './ModalShell';

const PaymentModal = ({
  isOpen,
  onClose,
  selectedPlan,
  billingInterval = 'monthly',
  checkoutAmount,
  onPaymentSuccess,
  onPaymentError,
}) => {
  const [cardholderName, setCardholderName] = useState('');

  const open = Boolean(isOpen && selectedPlan);

  const handlePaymentSuccess = (data) => {
    if (onPaymentSuccess) {
      onPaymentSuccess(data);
    }
  };

  const handlePaymentError = (error) => {
    if (onPaymentError) {
      onPaymentError(error);
    }
  };

  return (
    <ModalShell
      isOpen={open}
      onClose={onClose}
      labelledBy="payment-modal-title"
      panelClassName="max-w-md"
    >
      {selectedPlan && (
        <div className="relative bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-xl w-full p-6 sm:p-8 overflow-hidden">
          <button
            type="button"
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors z-10 p-1 !rounded-xl"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>

          <h3
            id="payment-modal-title"
            className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-50 mb-4"
          >
            Complete Your Subscription
          </h3>

          <div className="mb-6">
            <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-2 text-sm sm:text-base">
              Selected Plan:
            </h4>
            <div className="bg-gray-50 dark:bg-gray-950/50 rounded-xl border border-gray-200 dark:border-gray-800 p-3 sm:p-4">
              <div className="flex justify-between items-center gap-2">
                <span className="font-medium text-sm sm:text-base text-gray-900 dark:text-gray-100">
                  {selectedPlan.name}
                </span>
                <span className="text-lg sm:text-xl font-bold whitespace-nowrap text-gray-900 dark:text-gray-50">
                  ${Number(checkoutAmount ?? selectedPlan.price ?? 0).toFixed(2)}
                  <span className="text-sm font-normal text-gray-600 dark:text-gray-400 ml-1">
                    /{billingInterval === 'yearly' ? 'year' : 'month'}
                  </span>
                </span>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-1">
                {selectedPlan.description}
              </p>
            </div>
          </div>

          <StripeSubscriptionPaymentForm
            key={`${selectedPlan.id}-${billingInterval}-${checkoutAmount}`}
            subscriptionId={selectedPlan.id}
            billingInterval={billingInterval}
            amount={checkoutAmount ?? selectedPlan.price}
            onSuccess={handlePaymentSuccess}
            onError={handlePaymentError}
            metadata={{
              cardholderName: cardholderName,
              onCardholderNameChange: setCardholderName,
            }}
          />
        </div>
      )}
    </ModalShell>
  );
};

export default PaymentModal;
